<template>
  <v-row class="content-5">
    <v-col class="col-12">
      <!-- header -->
      <v-row class="font-weight-black">
        <v-col class="col-2">
          {{ $t('extraRides.ascent') }}
        </v-col>
        <v-col class="col-2">
          {{ $t('extraRides.descent') }}
        </v-col>
        <v-col class="col-4">
          {{ $t('extraRides.comment') }}
        </v-col>
        <v-col class="col-2">
          {{ $t('extraRides.addedBy') }}
        </v-col>
        <v-col class="col-2">
          {{ $t('extraRides.updatedAt') }}
        </v-col>
      </v-row>

      <!-- iterate extra rides -->
      <v-row
        v-for="(extraRide, extraRideIndex) in extraRides"
        :key="extraRideIndex"
        class="border-top"
      >
        <v-col class="col-2 py-1">
          {{ extraRide.ascentDate | formatDate('HH:mm') }}
        </v-col>
        <v-col class="col-2 py-1">
          {{ extraRide.descentDate | formatDate('HH:mm') }}
        </v-col>
        <v-col class="col-4 py-1">
          {{ extraRide.comment }}
        </v-col>
        <v-col class="col-2 py-1">
          {{ extraRide.user.firstname }} {{ extraRide.user.surname }}
        </v-col>
        <v-col class="col-2 py-1">
          {{ extraRide.updatedAt | formatDate('DD.MM.YYYY HH:mm') }}
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'GroupsHelper',
  props: {
    extraRides: {
      type: Array,
      required: true,
    },
  },
}
</script>
